import React, { useEffect, useState } from 'react';
import '../style.css';
import { rlsBypassQuery } from '../api/rlsBypassQuery';

function ReportList() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [showExpired, setShowExpired] = useState(false);

  useEffect(() => {
    async function fetchReports() {
      try {
        const data = await rlsBypassQuery({
          table: 'sevs_expiry_management',
          select: '*,customer_model_reports(*)',
          orderBy: { column: 'id', ascending: true },
          limit: 1000,
        });

        setReports(data);
      } catch (error) {
        console.error('Error fetching reports via edge function:', error.message);
        setReports([]);
      } finally {
        setLoading(false);
      }
    }

    fetchReports();
  }, []);
//code to fetch all other status 
  const doneAndVariationReports = reports.filter(
  (item) => item.status !== 'Done'&& item.status !== 'Cant be renewed'
);

//code to fetch expired details
 const expiredSev = reports.filter(
  (item) => item.status === 'Cant be renewed'
);

//fetch the reason from the json data



  // Toggle to expand or collapse the row
  
const handleToggleExpand = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };
  

  return (
                   <div className="container-fluid shadow"style={{ backgroundColor: '#eef2f7'}}>
    
                   <h1 className="text-center fw-bold heading-title scroll-target mb-4">SEVS Expiry Details</h1>
                   <p className="text-muted mb-4 text-center">
          We provide an up-to-date list of all active SEV approvals to help you stay
          informed and compliant.
        
          For full transparency, you can also access our archive of expired SEV records. <br/>
          Note: Please note that expired approvals are available <strong>for reference only </strong> 
          and <strong>cannot be renewed</strong>.
        
        <button
                               
                               
           className={`btn btn-link text-decoration-underline `}
          onClick={() => {
            setShowExpired(!showExpired);
            setExpandedId(null);
          }}
        >
          {showExpired ? 'Back To SEV Details' : 'View Expired SEVs'}

                              </button>
        </p>
                   

      {loading ? (
        <p>Loading...</p>
      )  : (showExpired ? expiredSev: doneAndVariationReports).length === 0 ? (
        <p>No reports found.</p>
      ) : (
                <>
                  <div
                    style={{
                      maxHeight: showAll ? '300px' : 'auto',
                      overflowY: showAll ? 'auto' : 'visible',
                    }}
                  >
                    <div className="table-responsive " style={{ borderTop: "1px solid #101110ff", paddingTop: "12px" }}>
                      <table className="table table-hover transparent-table">
                        <thead >
                          <tr>
                            <th>S/N</th>
                            <th>CAR Details</th>
                            <th>Chassis Code</th>
                            <th>SEV Entry</th>
                            <th>SEV Expiry</th>
                            <th>MRE Approval</th>
                            <th>Status</th>
                            
                            
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {(showExpired ? expiredSev:doneAndVariationReports)
                          
                          .map((item, index) => (
                            
                            <React.Fragment key={item.id}>
                              
                              <tr>
                                <td data-label="S/N">{index + 1}</td>
                                <td data-label="Car Details">{item.customer_model_reports?.make}&nbsp;{item.customer_model_reports?.model}</td>
                                <td data-label="Chassis Code">{item.customer_model_reports?.chassis_code}</td>
                                <td data-label="Sev Entry">{item.customer_model_reports?.sevs_entry}</td>
                                <td data-label="Sev Expiry">{item.customer_model_reports?.sevs_expiry}</td>
                                <td data-label=" MR Approval">{item.customer_model_reports?.mr_approval}</td>
                                <td data-label="Status">
                                  <span 
                                  className={`${item.status === 'MR Variation Applied' ? 'text-primary' :
                                               item.status === 'Approved Sevs Renewal' ? 'text-warning' :
                                               item.status === 'Applied Renew' ? 'text-success' :
                                               item.status === 'Cant be renewed' ? 'text-danger' :
  'text-primary'


  
}`}>
  {item.status==='Done' ? '' :item.status} {item.status==='MR Variation Applied' && (
                                       ' and Waiting for rovers approval '
                                     )}{item.status==='Applied Renew' && (
                                       ' and Waiting for rovers approval '
                                     )}</span></td>
                                
                                
                               
                              
                                  <td className="text-center">

                              
                                  
                                   
                              <span
                                style={{ cursor: 'pointer', fontSize: '18px'}}
                                onClick={() => handleToggleExpand(item.id)}
                              >
                                {expandedId === item.id ? <i className="bi bi-chevron-up"></i>  // 👆 Icon when EXPANDED
        : <i className="bi bi-chevron-down"></i> 
    }
                              </span>
                            
                                </td>
                                
                              </tr>
    
                            {/*View More details*/}
                                {expandedId === item.id && (
                            
                            <tr>
                              
                              <td colSpan="7">
                                
                                {/* Expanded details */}
                                <div className="row custom-colour">
                                  <div className="col-md-3">
                                    <strong>Engine Details</strong>
                                   <p>Option 1 <strong>:</strong>&nbsp;{item.customer_model_reports?.engine_option_1}</p>
                                   {item.customer_model_reports?.engine_option_2&&item.customer_model_reports?.engine_option_2?.trim()!=='-' && (
                                       <p>Option 2 <strong>:</strong>&nbsp;{item.customer_model_reports?.engine_option_2}</p>
                                     )}
                                     
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Transmission & Drivetrain</strong>
                                    <p>Transmission <strong>:</strong>&nbsp;{item.customer_model_reports?.transmission}<br/>
                                    Drivetrain <strong>:</strong>&nbsp;{item.customer_model_reports?.drivetrain}</p>
                                    
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Seat Details</strong>
                                    <p>Option 1 <strong>:</strong>&nbsp;{item.customer_model_reports?.seats_option_1}</p>
                                     {item.customer_model_reports?.seats_option_2&&item.customer_model_reports?.seats_option_2?.trim()!=='-' && (
                                       <p>Option 2 <strong>:</strong>&nbsp;{item.customer_model_reports?.seats_option_2}</p>
                                     )}
                                     {item.customer_model_reports?.seats_option_3&&item.customer_model_reports?.seats_option_3?.trim()!=='-' && (
                                       <p>Option 3 <strong>:</strong>&nbsp;{item.customer_model_reports?.seats_option_3}</p>
                                     )}
                                     
                                  </div>
                                  
                                  <div className="col-md-3">
                                    <strong>Dates</strong>
                                    <p>Start <strong>:</strong>&nbsp;{item.customer_model_reports?.start_date}<br/>
                                    End <strong>:</strong>&nbsp;{item.customer_model_reports?.end_date}</p>
                                    </div>
                                   <div className="col-md-3">
                                    <strong>Reference </strong>
                                    <p>WI Ref <strong>:</strong>&nbsp;{item.customer_model_reports?.mr_wi_reference}<br/>
                                    VC Ref <strong>:</strong>&nbsp;{item.customer_model_reports?.mr_vc_reference}</p>
                                  
                                  </div>
                                   <div className="col-md-3">
                                    <strong>SEVS details</strong>
                                    
                                    <p>Sevs expiry <strong>:</strong>&nbsp;{item.customer_model_reports?.sevs_expiry}</p>
                                    
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Requirement</strong>
                                    <p>Origin <strong>:</strong>&nbsp;{item.customer_model_reports?.origin_requirements}<br/>
                                    Body type <strong>:</strong>&nbsp;{item.customer_model_reports?.body_type}<br/>
                                    Cats or km required <strong>:</strong>&nbsp;{item.customer_model_reports?.cats_or_km_required}<br/>
                                    Camper conversion <strong>:</strong>&nbsp;{item.customer_model_reports?.camper_conversion_required}<br/>
                                  Welcab type <strong>:</strong>&nbsp;{item.customer_model_reports?.welcab_type}</p>
                                  </div>
                                   
                                 <div className="col-md-3">
                                 {item.customer_model_reports?.mr_variation_description&&item.customer_model_reports?.mr_variation_description?.trim()!=='' && (
                                    <div>
                                      <strong>Variation Description</strong>
                                      <p> <strong></strong>&nbsp;{item.customer_model_reports?.mr_variation_description}</p>
                                       
                                     </div>
                                  )}
                                </div>
                                 <div className="col-md-3">
                                 {item.status==='Cant be renewed' && (
                                    <div>
                                      <strong>Reason</strong>
                                      <p>

                                         {(() => {
        try {
          let logs = item.sevs_activity_logs;

         
          if (typeof logs === 'string') {
            logs = JSON.parse(logs);
          }

          if (!logs || typeof logs !== 'object') return 'No reason available';

          // Sort timestamps 
          const sortedTimestamps = Object.keys(logs).sort((a, b) => new Date(b) - new Date(a));

          for (const timestamp of sortedTimestamps) {
            const users = logs[timestamp];
            if (users && typeof users === 'object') {
              for (const email in users) {
                const logEntry = users[email];
                if (logEntry?.reason) {
                  return logEntry.reason;
                }
              }
            }
          }

          return 'No reason available';
        } catch (error) {
          console.error('Error reading reason from logs:', error);
          return 'No reason available';
        }
      })()}
  
  





                                        
 </p>
                                       
                                     </div>
                                  )}
                                </div>
                            
                                </div>
                                
                              </td>
</tr>
                            
                          )}


                        
                             
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
      
                  
                </>
              )}
            </div>
          
        );
      };

export default ReportList;
